const UNDEFINED_LOGIN = {
  login: undefined
};

const LOCAL_STORAGE_KEY = 'login';

export const loadLogin = () => {

  try {
    const serialized = localStorage.getItem(LOCAL_STORAGE_KEY);

    if (!serialized) {
      return UNDEFINED_LOGIN;
    }

    return {
      login: JSON.parse(serialized)
    }
  }
  catch (err) {
    return UNDEFINED_LOGIN;
  }
};


export const saveLogin = (login) => {

  try {
    const serialized = JSON.stringify(login);
    localStorage.setItem(LOCAL_STORAGE_KEY, serialized);
  }
  catch (err) {}
};


export const clearLocalStorage = () => {
  try {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  }
  catch (err) {}
};


// WEBPACK FOOTER //
// ./src/auth/localStorage.js